module.exports = __webpack_public_path__ + "static/img/home-img2.b3626fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img2.png
// module id = 1F/l
// module chunks = 1